/**
 * Strategy, how dropdown filter can behave
 */
export var SelectionVariant;
(function (SelectionVariant) {
    /**
     * Only one element can be selected at the time
     */
    SelectionVariant["Single"] = "Single";
    /**
     * Any number of elements can be selected at the time
     */
    SelectionVariant["Multiple"] = "Multiple";
})(SelectionVariant || (SelectionVariant = {}));
